import {globalCatch} from "../../../_services/global-catch";
import {SET_TRANSFER_EXPEDIENT_STATUS} from "./constants";
import {transferAcademicRecordsApi} from "../../../_services/expedient-service";
import {toastService} from "../../../_services/toast-service";
import {t} from "../../../_i18n"

export const setTransferExpedientStatus = payload => ({type: SET_TRANSFER_EXPEDIENT_STATUS, payload});

export const getTransferExpedientStatus = (studentId) => globalCatch.catch( async dispatch => {
    const transferExpedientStatus = await(await transferAcademicRecordsApi()).transferAcademicRecordsControllerShow(studentId);
    dispatch(setTransferExpedientStatus(transferExpedientStatus));
})

export const uploadTransferExpedientDocument  = (studentId, file, academicProgramId) => globalCatch.catch( async dispatch => {
    const response = {error: null, data: null};

    try {
        response.data = await(await transferAcademicRecordsApi()).transferAcademicRecordsControllerStore(studentId, {file, academicProgramId});
        toastService.showToast({message:t("Solicitud enviada correctamente"), type:'info'});
    } catch (e) {
        if (e?.body?.message) {
            response.error = e.body.message;
            toastService.showToast({message: e.body.message, type: 'danger'});
        } else if (e?.body?.errors) {
            const errorObject = e.body.errors;
            const errorKeys = Object.keys(errorObject);
            const message = errorObject[errorKeys[0]][0];
            toastService.showToast({message: message , type: 'danger'});
        } else {
            toastService.showToast({message: t("Ha ocurrido un error"), type: 'danger'});
        }
    }

    return response;
})
